import type { Message } from "./types";

const GUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isValidGuid(value: string): boolean {
  return GUID_PATTERN.test(value);
}

export function isValidConversationMessage(value: unknown): value is Message {
  if (!value || typeof value !== "object") return false;

  const message = value as Partial<Message>;
  return (
    typeof message.id === "string" &&
    (message.role === "user" || message.role === "assistant") &&
    typeof message.content === "string" &&
    typeof message.timestamp === "number" &&
    Number.isFinite(message.timestamp)
  );
}
